<template>
  <Content
    :content="content"
    :headline="headline"
    :title="title"
  />
</template>

<script>
import Content from 'Web/Layouts/Content.vue';

export default {
  inheritAttrs: false,
  components:{
    Content,
  },
  props: {
    content: {
      type: String,
      default: null,
    },
    headline: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
  }
}
</script>
